export class MotorVehMdl
{
    public Vehicle_DefType: number;
    public Vehicle_UsageCode: string;
    public Vehicle_PlateTypeCode: string;
    public Vehicle_PlateNo: string;
    public Vehicle_FLetter: string;
    public Vehicle_SLetter: string;
    public Vehicle_TLetter: string;
    public Vehicle_ModelCode: string;
    public Vehicle_MakeCode: string;
    public Vehicle_CoverageType: string;
    public Vehicle_Age: string;
    public Vehicle_FullPlateNoEn: string;
    public Vehicle_FullPlateNoAr: string;
    public Vehicle_SequenceNo: string;
    public Vehicle_CustomId: string;

    public Vehicle_ChassisNo: string;
    public Vehicle_TypeCode: string;
    public Vehicle_ManfYear: string;
    public Vehicle_Color: string;
    public Vehicle_LicenseExpDate: string;
    public Vehicle_NoofPsng: string;
    public Vehicle_SI: string;
    public Vehicle_NetAmount: string;
    public RiskIssueDateEn: string;
    public RiskEffFromEn: string;
    public RiskEffToEn: string;
    public RiskIssueDateAr: string;
    public RiskEffFromAr: string;
    public RiskEffToAr: string;
    public LangFlag: string;
    public Vehicle_Cover_AdminFee: string;
    public CustomIdIssuenceDate: string;
    public CustomIdIssuenceDate_Hijri: string;
    public Vehicle_ColorID: string;
    public VehicleWeight: string;
    public TrimId: string;
    public VehicleRegCityCode: string;
    public VehicleRegRegionCode: string;
    public Insured_RiskCity: string;
    public Insured_RiskStreetName: string;
    public Insured_RiskDistName: string;
    public Vehicle_Mileage: string;
    public Vehicle_EquipedWithAlaram: string;
    public Veh_Restraints: string;
    public Veh_DistrictDesc: string;
    public Veh_StreetDesc: string;
    public Veh_PlateColour: string;
    public Vehicle_RegExpirydate: string;
    public Vehicle_BodyType: string;
    public Marketvalue: string;
    public AddonAccessories: string;
    public AddonAccessoriesDetails: string;
    public Vehicle_BodyTypeDesc: string;
    public YakeenVehicleRegCityCode: string;
    public YakeenVehicleRegRegionCode: string;
    public  Restriction_on_Use: string;

    public VehicleRegCity: string;
    public VehicleRegRegion: string;

    public VechileMakeEn: string;
    public VechileMakeAr: string;
    public VechileModelEn: string;
    public VechileModelAr: string;
    public NoOfPassengers: string;

    public UseOfVehcileEn: string;
    public UseOfVehcileAr: string;

    public PlateTypeEn: string;
    public PlateTypeAr: string;

    public VechTypeEn: string;
    public VechTypeAr: string;    
    public Transmission: string;    
    public EngineSize: string;    
    public  RearCamera: string;    
    public FrontCamera: string;    
    public FrontSensor: string;    
    public RearParkingSensor: string;    
    public AdaptiveControl: string;    
    public CrusieControl: string;    
    public AutoBrakingSystem: string;    
    public AntiLockBrakingSystem: string;   
    public DegreeCamera: string;   
    public  FireExtingushier: string;   
    public  ModificationsInCar: string;   
    public AxieWeight: string;    
    public MileagePerYear: string;   
    public ModificationsInCarDesc: string;
    public  Vehicle_RegExpirydateHijri:string;
    public  VehicleParkingNight: string;
    public  MakeImageUrl: string;
    
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MotorVehMdl.ts